angular.module('dpw.components')

    /**
     * @ngdoc Component
     * @name dpwErrorDisplayField
     * @description This component will only display an error message of the highest priority.
     *
     * @param {Array<String>} errorCodes - Errors that the field has, and the first error code has the highest priority.
     * @param {Object} messageConfig - Configure error message for each error code.
     */
    .component('dpwErrorDisplayField', {
        templateUrl: 'dpw-error-display-field.html',
        controller: [function () {
            var $ctrl = this;

            $ctrl.shouldDisplay = function () {
                return !_.isEmpty($ctrl.errorCodes) && !_.isEmpty($ctrl.getMessage());
            };

            $ctrl.getMessage = function () {
                var errorCode = _.first($ctrl.errorCodes);
                return _.get($ctrl.messageConfig, errorCode, '');
            };
        }],
        bindings: {
            errorCodes: '<',
            messageConfig: '<'
        }
    })

;